export default "__VITE_ASSET__BY8MKMfn__"